import React from 'react'
import PropTypes from 'prop-types'
import {
  Icon as TriangleIcon,
  SocialX,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import Icon from './Icon/Icon'

function SocialButtons({
  socialNetworks,
  page,
  share = false,
  url = '',
  className = '',
  useSquareIcons = false,
}) {
  const socialUrls = {
    default: {
      facebook: '//www.facebook.com/cgtrader/',
      linkedin: '//www.linkedin.com/company/cgtrader/',
      twitter: '//x.com/CG_Trader',
    },
    share: {
      facebook: '//www.facebook.com/sharer.php?u=',
      linkedin: '//www.linkedin.com/shareArticle?mini=true&url=',
      twitter: '//twitter.com/home?status=',
      pinterest: '//pinterest.com/pin/create/button/?url=',
    },
    iconNames: {
      facebook: 'facebook-f',
      linkedin: 'linkedin-in',
      twitter: 'twitter',
    },
    squareIconNames: {
      facebook: 'facebook-square',
      linkedin: 'linkedin',
      twitter: 'twitter-square',
      pinterest: 'pinterest-square',
    },
  }

  function returnUrl(network, sharable) {
    const params = '?utm_medium=Social%26utm_campaign=Share%26utm_source='

    if (sharable) {
      return socialUrls.share[network] + url + params + network
    }
    return socialUrls.default[network]
  }

  function renderIcon(network) {
    if (network === 'twitter') {
      return useSquareIcons ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#485c66',
            borderRadius: 4,
            width: 15,
            height: 15,
            paddingLeft: 4,
          }}
        >
          <TriangleIcon
            svgComponent={SocialX}
            color="light"
            size={{ width: 14, height: 14 }}
          />
        </div>
      ) : (
        <TriangleIcon
          svgComponent={SocialX}
          color="dark"
          size={{ width: 16, height: 16 }}
        />
      )
    }

    return (
      <Icon
        type={[
          'fab',
          useSquareIcons
            ? socialUrls.squareIconNames[network]
            : socialUrls.iconNames[network],
        ]}
        color="white"
      />
    )
  }

  return (
    <div className="social-buttons">
      <div className="row">
        {socialNetworks.map((network) => (
          <div className="col" key={network}>
            <a
              href={
                share ? returnUrl(network, true) : returnUrl(network, false)
              }
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              target="_blank"
              rel="noreferrer"
              className={`social-icon-circle social-icon-circle--${network} js-social-icon ${
                className || ''
              }`}
              data-social-network={network}
              data-page={page}
              aria-label={
                network === 'twitter' ? 'X (formerly Twitter)' : network
              }
            >
              {renderIcon(network)}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

SocialButtons.propTypes = {
  socialNetworks: PropTypes.array.isRequired,
  page: PropTypes.string.isRequired,
  share: PropTypes.bool,
  useSquareIcons: PropTypes.bool,
  url: PropTypes.string,
  className: PropTypes.string,
}

export default SocialButtons
